// extracted by mini-css-extract-plugin
module.exports = {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","menuHeader":"#f9f9fa","ProductReport":"eo_a bhu_a bhu_x bhu_j bhu_u bhu_bc bhu_pp bhu_up"};